export const WEEK_MONTH_CALENDER_START_DAY = 'monday';

const WEEK_DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

export const CALENDAR_WEEK_START_INDEX = WEEK_DAYS.indexOf(WEEK_MONTH_CALENDER_START_DAY);

export const orderCalendarWeekDays = (days) => [
  ...days.slice(CALENDAR_WEEK_START_INDEX),
  ...days.slice(0, CALENDAR_WEEK_START_INDEX),
];

export const getCalendarWeekdayOffset = (dayIndex) =>
  (dayIndex - CALENDAR_WEEK_START_INDEX + 7) % 7;
